import { render } from "./UserProfileLogo.vue?vue&type=template&id=62095ce5&scoped=true&ts=true"
import script from "./UserProfileLogo.vue?vue&type=script&lang=ts"
export * from "./UserProfileLogo.vue?vue&type=script&lang=ts"

import "./UserProfileLogo.vue?vue&type=style&index=0&id=62095ce5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62095ce5"]])

export default __exports__